module.exports = __webpack_public_path__ + "static/media/Jessica Miyake.15861add.png";